import * as React from 'react';
import {createPortal} from 'react-dom';

import {TooltipContent, TooltipProps} from './component';

export function TooltipReact({children, className, style, elref, slot, ...props}: TooltipProps) {
  const [host, setHost] = React.useState<HTMLElement | null>(null);
  const [shadowRoot, setShadowRoot] = React.useState<ShadowRoot | null>(null);
  const attachHost = React.useCallback((element: HTMLElement | null) => {
    setHost(element);
    setShadowRoot(element ? element.shadowRoot || element.attachShadow({mode: `open`}) : null);
  }, []);
  return React.createElement(
    `mp-react-tooltip`,
    {
      ref: attachHost,
      class: className,
      style,
      elref,
      slot,
      'data-tooltip': ``,
      role: `tooltip`,
      hidden: true,
      'aria-hidden': `true`,
      onClick: (event: React.MouseEvent) => event.stopPropagation(),
      onMouseDown: (event: React.MouseEvent) => event.stopPropagation(),
    },
    children,
    host && shadowRoot && createPortal(<TooltipContent {...props} host={host} />, shadowRoot),
  );
}
